<section class="makePaymentPage  my-4" [class.makePaymentPage__invoicesTable--compact]="isCompactView()">
  <div class="makePaymentPage__tableHeader container py-3">
    <div class="makePaymentPage__tableHeaderRow row d-none d-lg-flex">
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.status' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.invoice#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.due_date' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.invoice_balance' | cxTranslate }}</div>
      @if (!isCompactView()) {
        <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.promptPayLabel' | cxTranslate }}</div>
      }
    </div>
  </div>
  <div class="makePaymentPage__tableBody container">
    @if (isLoading()) {
      <app-loader/>
    } @else {
      @for (invoice of paymentList(); track invoice.originalInvoice) {
        <div class="makePaymentPage__tableRow row flex-column flex-lg-row my-3 py-4">
          <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.status' | cxTranslate }}: </div>
            <div class="d-flex align-items-center" [class.makePaymentPage__pastDue]="!isOpen(invoice.dueDate)">
              @if (!isOpen(invoice.dueDate)) {
                <img class="mr-2" src="icons/info_red.svg" [alt]="'makeAPayment.infoIconAlt' | cxTranslate">
              }
              <span>{{ getStatus(invoice.dueDate) | async }}</span>
            </div>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.invoice#' | cxTranslate }}: </div>

            <a href="javascript: void(0);" class="underline" (click)="invoicePdf(invoice.originalInvoice)">{{ invoice.originalInvoice }}</a>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.due_date' | cxTranslate }}: </div>
            <span>{{ CommonUtils.formatDate(invoice.dueDate, US_DATE_FORMAT, EU_DATE_FORMAT) }}</span>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.invoice_balance' | cxTranslate }}: </div>
            <span>{{ invoice.amount | currency }}</span>
          </div>

          @if (!isCompactView()) {
            <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
              <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.promptPayLabel' | cxTranslate }}: </div>
              <span [class.makePaymentPage__noPromptPay]="!isPromptPay(invoice)">{{ invoice.discPercent | number: '1.0-2' }}%</span>
            </div>
          }
        </div>
      }

      <sanofi-no-items-disclaimer [itemsList]="paymentList()" [text]="'makeAPayment.noInvoicesToDisplay' | cxTranslate" [mix]="'makePaymentPage__tableRow'"/>
    }
  </div>
</section>
